import axios from 'axios';
import { API } from './constants';

/**
 * Sube un archivo al dossier del cliente, frenando si parece de OTRO cliente.
 *
 * En octubre de 2026 la ficha de un cliente apareció con el white paper y el
 * caso de estudio de otro, cargados como documentos de respaldo. Ese bloque es
 * la fuente autoritativa de cada generación. El backend ahora responde 409
 * (`cliente_ajeno`) cuando el documento nombra a otro cliente y no a este; acá
 * se le pregunta al operador y, sólo si confirma, se vuelve a mandar.
 *
 * Devuelve la respuesta de axios, o null si el operador canceló.
 */
export async function subirAlDossier(clientId, fd, config = {}) {
  const url = `${API}/clients/${clientId}/dossier/upload`;
  try {
    return await axios.post(url, fd, config);
  } catch (e) {
    const det = e.response?.data?.detail;
    if (e.response?.status !== 409 || det?.code !== 'cliente_ajeno') throw e;
    const ok = window.confirm(
      `${det.message}\n\n¿Seguro que querés guardarlo en esta ficha?`);
    if (!ok) return null;
    fd.set('confirmar_ajeno', '1');
    return axios.post(url, fd, config);
  }
}

/** El texto de error de una subida, aunque `detail` venga como objeto. */
export function errorDeSubida(e, porDefecto) {
  const det = e?.response?.data?.detail;
  if (typeof det === 'string') return det;
  return det?.message || porDefecto;
}
